import { render, staticRenderFns } from "./TreeviewPeople.vue?vue&type=template&id=08c7fa11&scoped=true&"
import script from "./TreeviewPeople.vue?vue&type=script&lang=js&"
export * from "./TreeviewPeople.vue?vue&type=script&lang=js&"
import style0 from "./TreeviewPeople.vue?vue&type=style&index=0&id=08c7fa11&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7fa11",
  null
  
)

export default component.exports